var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAnthropic(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "uuid-ff034291-aa19-42a6-9762-0e43a289aca7",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .uuid-2c871c02-808b-4ee9-82f8-6faa834e1ebd {\n        fill: #f2f2f2;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "uuid-d5a85502-a874-496f-91f0-2387fbe9ea6d",
    "data-name": "surface1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "uuid-2c871c02-808b-4ee9-82f8-6faa834e1ebd",
    d: "M17.36,9.86l4.89,12.28h2.68l-4.89-12.28h-2.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-2c871c02-808b-4ee9-82f8-6faa834e1ebd",
    d: "M11.69,17.28l1.67-4.32,1.67,4.32h-3.34ZM11.96,9.86l-4.88,12.28h2.73l1-2.58h5.11l1,2.58h2.73l-4.89-12.28h-2.8Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnthropic);
export default __webpack_public_path__ + "static/media/Anthropic.1054e48d663a9fc0df378c638b8ee35a.svg";
export { ForwardRef as ReactComponent };